import { Col, Collapse, Row, Space } from "antd";
import React from "react";

const Initiations = () => {
  const { Panel } = Collapse;
  const waterBellImages = Array.from({ length: 10 }, (_, index) => ({
    id: `waterbell-${index + 1}`,
    src: `https://pskagal.in/api/uploads/upakram/waterbell/${index + 1}.jpg`,
  }));

  const hpvImages = Array.from({ length: 7 }, (_, index) => ({
    id: `hpv-${index + 1}`,
    src: `https://pskagal.in/api/uploads/upakram/hpv/${index + 1}.jpg`,
  }));

  const grievanceImages = Array.from({ length: 1 }, (_, index) => ({
    id: `grievance-${index + 1}`,
    src: `https://pskagal.in/api/uploads/upakram/grievance/${index + 1}.png`,
  }));

  const bachatImages = Array.from({ length: 4 }, (_, index) => ({
    id: `bachat-${index + 1}`,
    src: `https://pskagal.in/api/uploads/upakram/bachat-gat/${index + 1}.png`,
  }));

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Collapse>
        <Panel header="HPV लसीकरण" key="1">
          <p>
            <b>
              ९ ते २६ वयोगटातील शाळा, कॉलेजमधील मुलींना गर्भाशयाच्या मुखाला
              कर्करोगाचा संभव होऊ नये साठी मुलींना HPV प्रतिबंधात्मक लसीकरणाची
              सुरुवात महाराष्ट्रात सर्वप्रथम कागल तालुक्यामधून करण्यात आली.
              गटविकास अधिकारी यांच्या अध्यक्षतेखाली तालुकास्तरीय समिती स्थापन
              करण्यात आली. या समितीच्या माध्यमातून पंचायत समितीकडील आरोग्य,
              शिक्षण विभाग व NGO सामाजिक संस्था यांच्या माध्यमातून लसीकरण
              मोहिमेचे नियोजन करण्यात आले. यासाठी मोठ्या प्रमाणावर पालकसभा घेऊन
              जनजागृती करण्यात आली. आजअखेर 8419 लाभार्थ्यांनी या योजनेचा लाभ
              घेतलेला आहे. अशाप्रकारे HPV लसीकरण मो‍हिम यशस्वीरित्या राबवण्यात
              आली.
            </b>
          </p>
          <Row gutter={[16, 16]}>
            {hpvImages.map((image) => (
              <Col key={image.id} xl={6} lg={6} md={12} sm={24} xs={24}>
                <img
                  src={image.src}
                  alt="HPV Image"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "scale-down",
                  }}
                />
              </Col>
            ))}
          </Row>
        </Panel>
        <Panel header="वॉटर बेल - प.स.सेस अनुदानातून विशेष तरतूद" key="2">
          <p>
            <b>
              उपक्रमाचा उद्देष - <br />
              उन्हाळ्याच्या दिवसात अंगणवाडी बालकाना वेळेवर पाणी पिण्याची सवय
              लागावी यासाठी वॉटर बेल हि संकल्पना तालुक्यातील सर्व अंगणवाडीमध्ये
              यशस्वी रित्या राबवण्यात आली. बालकाना वेळेवर पाणी पिण्याची सवय
              लागावी व त्यांना डिहायड्रेशन होऊ नये, डोकेदुखी, पोटदुखी, चक्कर
              येणे असे प्रकार घडू नयेत यासाठी वॉटर बेल या संकल्पनेचा हा मुख्य
              उद्देष आहे.
            </b>
          </p>
          <Row gutter={[16, 16]}>
            {waterBellImages.map((image) => (
              <Col key={image.id} xl={6} lg={6} md={12} sm={24} xs={24}>
                <img
                  src={image.src}
                  alt="Water Bell Image"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "scale-down",
                  }}
                />
              </Col>
            ))}
          </Row>
        </Panel>
        <Panel
          header="महाराष्ट्र राज्य जीवनोन्नती अभियान अंतर्गत बचत गटांचे स्टॉल तालुक्यातील यात्रा/जत्रा मध्ये उभारुन व्यापारास प्रात्साहन देणे."
          key="3"
        >
          <p>
            <b>
              तालुक्यामध्ये जत्रा/यात्रांमध्ये बचत गटांचे स्टॉल लाऊन व्यापारास
              प्रोत्साहन दिले –<br /> महाराष्ट्र राज्य जीवनोन्नती अभियानाच्या
              माध्यमातून बाचणी, सोनाळी, यमगे, सावर्डे बुद्रुक येथील 23 समुह
              संख्यांनी सहभाग घेऊन खाद्यापदार्थांची स्टॉल उभारणी केली
            </b>
          </p>
          <Row gutter={[16, 16]}>
            {bachatImages.map((image) => (
              <Col key={image.id} xl={6} lg={6} md={12} sm={24} xs={24}>
                <img
                  src={image.src}
                  alt="Bachhat Gat Image"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "scale-down",
                  }}
                />
              </Col>
            ))}
          </Row>
        </Panel>
        <Panel
          header="बाल विवाह / गर्भ लिंग  निदान / स्त्री भ्रुण हत्या तक्रारीसाठी  विशेष सुविधा."
          key="4"
        >
          <p>
            <b>
              उपक्रमाचा उद्देश -<br /> २०२५ मध्ये, "निरोगी सुरुवात, आशादायक
              भविष्य " या थीमसह माता आणि नवजात बालकांच्या आरोग्यावर लक्ष
              केंद्रित करुन ही थीम मुलांसाठी निरोगी सुरुवात आणि भविष्यासाठी
              सकारात्मक दृष्टिकोन सुनिश्चित करुन माता आणि नवजात बालकांच्या
              आरोग्याला प्राधान्य देण्यासाठी (WHO) ने अधोरेखित केले आहे. त्या
              अनुषंगाने पंचायत समितीच्या माध्यमातून कागल तालुका
              कार्यक्षेत्रामध्ये बालविवाह, गर्भलिंग निदान, स्री भ्रुण हत्या
              यासारण्या घटना होऊ नयेत यासाठी विशेष पोर्टल सुरु केले आहे.
            </b>
          </p>
          <p>
            <b>
              कागल तालुका कार्यक्षेत्रामध्ये बाल विवाह, गर्भ लिंग निदान,
              स्रीभ्रुण हत्या यासारख्या घटना घडू नयेत यासाठी पंचायत समितीच्या
              संकेतस्थळावर माहिती देण्याची सोय केलीली आहे. याबाबत गोपनियता
              राखण्यास मदतही होणार आहे. तसेच याबाबत तक्रार प्राप्त होताच याबाबत
              तात्काळ कार्यवाही होण्यास मदत होणार आहे.
            </b>
          </p>
          <Row gutter={[16, 16]}>
            {grievanceImages.map((image) => (
              <Col key={image.id} xl={24} lg={24} md={24} sm={24} xs={24}>
                <img
                  src={image.src}
                  alt="Grievance Image"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "scale-down",
                  }}
                />
              </Col>
            ))}
          </Row>
        </Panel>
      </Collapse>
    </Space>
  );
};

export default Initiations;
